<section id="recomUnis" class="bg-gray-50">
	<div class="container">
		<div class="divider">
			<div class="pb-8">
				<div class="flex items-center justify-between">
					<div>
						<h2
							class="hidden capitalize sm:block sm:text-xl sm:leading-6 sm:font-bold sm:text-gray-900"
						>
							{{ product() }} Universities
						</h2>
						<h2
							class="text-xl font-bold leading-6 text-gray-900 capitalize sm:hidden"
						>
							{{ product() }} Uni's
						</h2>
					</div>
					<div class="flex items-center gap-3">
						<p class="carousel-pagination carousel-index-recommended"></p>
						<div class="hidden gap-3 sm:flex">
							<div
								data-toggle="tab"
								role="tab"
								aria-label="Prev"
								class="bg-white carousel-navigation swiper-button-prev swiper-button-prev-recommended"
							></div>
							<div
								data-toggle="tab"
								role="tab"
								aria-label="Next"
								class="bg-white carousel-navigation swiper-button-next swiper-button-next-recommended"
							></div>
						</div>
					</div>
				</div>
			</div>
			<swiper-container #swiperRef init="false">
				@for (uni of recommendedUnis(); track uni.id) {
					<swiper-slide>
						<uc-recommended-uni-card [uni]="uni" [product]="product()" />
					</swiper-slide>
				}
			</swiper-container>
		</div>
	</div>
</section>
